import request from '@/utils/request'

// 轮播图
export function getBanner() {
  return request({
    url: '/api/szxh/list/rotation',
    method: 'get'
  })
}

// 党的建设列表
export function getPartyList(params) {
  return request({
    url: '/api/szxh/list/party',
    method: 'get',
    params
  })
}

// 协会概况
export function getGeneralList(params) {
  return request({
    url: '/api/szxh/list/general',
    method: 'get',
    params
  })
}

// 领导简介
export function getLeaderList(params) {
  return request({
    url: '/api/szxh/list/leader',
    method: 'get',
    params
  })
}

// 协会要闻
export function getNewsList(params) {
  return request({
    url: '/api/szxh/list/news',
    method: 'get',
    params
  })
}

// 政策法规类型接口
export function getPolicyType(params) {
  return request({
    url: '/api/szxh/dict/type/policy_rules_type',
    method: 'get',
    params
  })
}

// 政策法规
export function getPolicyList(params) {
  return request({
    url: '/api/szxh/list/policy',
    method: 'get',
    params
  })
}

// 公示公告
export function getPublicityList(params) {
  return request({
    url: '/api/szxh/list/publicity',
    method: 'get',
    params
  })
}

// 文件通知
export function getNoticeList(params) {
  return request({
    url: '/api/szxh/list/notice',
    method: 'get',
    params
  })
}

// 曝光台
export function getExposureList(params) {
  return request({
    url: '/api/szxh/list/exposure',
    method: 'get',
    params
  })
}

// 会员风采
export function getUnitList(params) {
  return request({
    url: '/api/szxh/list/unit/bearing',
    method: 'get',
    params
  })
}

// 会员风采风类
export function getUnitType(params) {
  return request({
    url: '/api/szxh/list/unit/type',
    method: 'get',
    params
  })
}

// 联系我们
export function getContact() {
  return request({
    url: '/api/szxh/get/contact',
    method: 'get'
  })
}

// 友情链接
export function getLinkList() {
  return request({
    url: '/api/szxh/list/link',
    method: 'get'
  })
}

// 查询产品行业列表
export function getListIndustry() {
  return request({
    url: '/api/szxh/list/product/industry',
    method: 'get'
  })
}

// 查询产品详情列表
export function getListProductDetail(params) {
  return request({
    url: '/api/szxh/list/product/detail',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js